import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { RouteSegments } from '@cbridge-packages/routing-client-admin';

export const ToolbarActions: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <Stack direction={'row'} spacing={2} sx={{
      alignItems: 'center',
    }}>
      <Button
        color={'secondary'}
        endIcon={<OpenInNewIcon />}
        href={RouteSegments.Help}
        target={'_blank'}
      >
        {t('text:navigation.help')}
      </Button>
    </Stack>
  );
};
